import { render, staticRenderFns } from "./dictEditorModal.vue?vue&type=template&id=68b9ac20&scoped=true"
import script from "./dictEditorModal.vue?vue&type=script&lang=js"
export * from "./dictEditorModal.vue?vue&type=script&lang=js"
import style0 from "./dictEditorModal.vue?vue&type=style&index=0&id=68b9ac20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9ac20",
  null
  
)

export default component.exports